import { DivIcon, LatLng } from "leaflet";
import React from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { Cluster, ClusterConfig } from "../config";
import MapOverlay from "../MapOverlay";
import { ViewData } from "../types";
import "./HomePage.css";
import LatencySection from "./LatencySection";
import Timeline from "./Timeline";

const center = new LatLng(0, 0);
const markerIcon = new DivIcon({
  className: "custom-div-icon",
  html: `<div style="background-color: #1b60f5; width: 16px; height: 16px; border-radius: 50%;"></div>`,
  iconSize: [16, 16],
  iconAnchor: [8, 8],
});

interface HomePageProps {
  views: ViewData[];
  selectedCluster: Cluster;
  configs: Record<Cluster, ClusterConfig>;
  locationsCount: number;
  onClusterChange?: (cluster: Cluster) => void;
}

const HomePage: React.FC<HomePageProps> = ({
  views,
  selectedCluster,
  configs,
  locationsCount,
  onClusterChange,
}) => {
  return (
    <div className="home-page">
      {/* Map Container */}
      <div className="home-page__map-container">
        <MapContainer
          key={selectedCluster}
          center={center}
          zoom={1}
          style={{ height: "100%", width: "100%" }}
          zoomControl={false}
          scrollWheelZoom={false}
          doubleClickZoom={false}
          touchZoom={false}
          dragging={false}
        >
          <TileLayer
            url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
            maxZoom={19}
          />
          {views.length > 0 && views[0].location !== undefined && (
            <Marker
              key={views[0].view}
              position={[views[0].location[0], views[0].location[1]]}
              icon={markerIcon}
            >
              <Popup>
                <div>
                  <strong>View: {views[0].view}</strong><br />
                  Location: {views[0].locationName}<br />
                  Status: {views[0].status}<br />
                  {views[0].block && (
                    <>Block Height: {views[0].block.height}<br /></>
                  )}
                  {views[0].startTime && (
                    <>Start Time: {new Date(views[0].startTime).toLocaleTimeString()}<br /></>
                  )}
                </div>
              </Popup>
            </Marker>
          )}
          <MapOverlay numValidators={locationsCount} />
        </MapContainer>
      </div>

      {/* Latency Section */}
      <LatencySection
        views={views}
        selectedCluster={selectedCluster}
        configs={configs}
        onClusterChange={onClusterChange}
      />

      {/* Timeline Section */}
      <Timeline views={views} />
    </div>
  );
};

export default HomePage;
